module.exports = __webpack_public_path__ + "static/media/terassa.c71c4349.jpeg";